import { TableColumnsType } from "antd";
import { DataType } from "../../interfaces/my-courses-summary.interface";

export const defaultColumns = () => {
  const columns: TableColumnsType<DataType> = [
    {
      title: "Course description:",
      onHeaderCell: () => ({ style: { backgroundColor: "#ced4da" } }),
      children: [
        {
          title: "Course code",
          dataIndex: "courseCode",
          key: "courseCode",
          fixed: "left",
          onHeaderCell: () => ({ style: { backgroundColor: "#ced4da" } }),
        },
        {
          title: "Course name",
          dataIndex: "courseName",
          key: "courseName",
          fixed: "left",
          onHeaderCell: () => ({ style: { backgroundColor: "#ced4da" } }),
        },
        {
          title: "Registration type",
          dataIndex: "registrationType",
          key: "registrationType2",
          fixed: "left",
          onHeaderCell: () => ({ style: { backgroundColor: "#ced4da" } }),
        },
      ],
    },
    {
      title: "Registration status:",
      onHeaderCell: () => ({ style: { backgroundColor: "#cfeaf4" } }),
      children: [
        {
          title: "Registration date",
          dataIndex: "createdAt",
          key: "createdAt",
          onHeaderCell: () => ({ style: { backgroundColor: "#cfeaf4" } }),
        },
        {
          title: "Registration status",
          dataIndex: "status",
          key: "status",
          onHeaderCell: () => ({ style: { backgroundColor: "#cfeaf4" } }),
        },
        {
          title: "Payment method",
          dataIndex: "type",
          key: "type",
          onHeaderCell: () => ({ style: { backgroundColor: "#cfeaf4" } }),
        },
        {
          title: "Cheque received",
          dataIndex: "chequeReceived",
          key: "chequeReceived",
          onHeaderCell: () => ({ style: { backgroundColor: "#cfeaf4" } }),
        },
        {
          title: "Date received",
          dataIndex: "receivedAt",
          key: "receivedAt",
          onHeaderCell: () => ({ style: { backgroundColor: "#cfeaf4" } }),
        },
        {
          title: "Waitlist number",
          dataIndex: "waitlist",
          key: "waitlist",
          onHeaderCell: () => ({ style: { backgroundColor: "#cfeaf4" } }),
        },
        {
          title: "Total paid",
          dataIndex: "amount",
          key: "amount",
          onHeaderCell: () => ({ style: { backgroundColor: "#cfeaf4" } }),
        },
        {
          title: "Difference (owing)",
          dataIndex: "balance",
          key: "balance",
          onHeaderCell: () => ({ style: { backgroundColor: "#cfeaf4" } }),
        },
        {
          title: "Paying options",
          dataIndex: "options",
          key: "options",
          onHeaderCell: () => ({ style: { backgroundColor: "#cfeaf4" } }),
        },
      ],
    },
    {
      title: "Course grade",
      onHeaderCell: () => ({ style: { backgroundColor: "#ffe5c3" } }),
      children: [
        {
          title: "Grade status",
          dataIndex: "gradeStatus",
          key: "gradeStatus",
          onHeaderCell: () => ({ style: { backgroundColor: "#ffe5c3" } }),
        },
        {
          title: "Final grade",
          dataIndex: "finalGrade",
          key: "finalGrade",
          onHeaderCell: () => ({ style: { backgroundColor: "#ffe5c3" } }),
        },
      ],
    },
    {
      title: "Download",
      children: [
        {
          title: "Letter or Certificate",
          dataIndex: "actions",
          key: "actions",
        },
      ],
    },
  ];

  return columns;
};
